(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/query-selectors/assets/javascripts/api/select-get-player-wagers.js') >= 0) return;  svs.modules.push('/components/tipsen/query-selectors/assets/javascripts/api/select-get-player-wagers.js');
"use strict";


const tipsenApi = svs.components.tipsen.store.tipsenApi;

const selectReducePaginationKeys = (state, _ref) => {
  var _queryData$data;
  let count = _ref.count,
    status = _ref.status,
    productId = _ref.productId,
    pagingSortKey = _ref.pagingSortKey,
    accObj = _ref.accObj;
  if (!accObj) {
    accObj = {
      currentKeys: [pagingSortKey],
      nextKey: null
    };
  }
  const queryData = tipsenApi.endpoints.getPlayerWagers.select({
    count,
    status,
    productId,
    pagingSortKey
  })(state);
  if (queryData !== null && queryData !== void 0 && (_queryData$data = queryData.data) !== null && _queryData$data !== void 0 && _queryData$data.wagers) {
    const wagers = queryData.data.wagers;
    if (queryData.data.moreItems) {
      const lastWagersPaginationKey = wagers[wagers.length - 1].pagingSortKey;
      if (accObj.nextKey) {
        accObj.currentKeys.push(accObj.nextKey);
      }
      if (accObj.nextKey !== lastWagersPaginationKey) {
        accObj.nextKey = lastWagersPaginationKey;
      }
      return selectReducePaginationKeys(state, {
        count,
        status,
        productId,
        pagingSortKey: lastWagersPaginationKey,
        accObj
      });
    } else if (accObj.nextKey && !queryData.data.moreItems) {
      accObj.currentKeys.push(accObj.nextKey);
      accObj.nextKey = null;
    }
  }
  return accObj;
};

const selectReduceWagerCount = (state, _ref2) => {
  var _queryData$data2;
  let count = _ref2.count,
    status = _ref2.status,
    productId = _ref2.productId,
    pagingSortKey = _ref2.pagingSortKey,
    _ref2$wagerCount = _ref2.wagerCount,
    wagerCount = _ref2$wagerCount === void 0 ? 0 : _ref2$wagerCount;
  const queryData = tipsenApi.endpoints.getPlayerWagers.select({
    count,
    status,
    productId,
    pagingSortKey
  })(state);
  if (queryData !== null && queryData !== void 0 && (_queryData$data2 = queryData.data) !== null && _queryData$data2 !== void 0 && _queryData$data2.wagers) {
    const wagers = queryData.data.wagers;
    wagerCount += wagers.length;
    if (queryData.data.moreItems) {
      const lastWagersPaginationKey = wagers[wagers.length - 1].pagingSortKey;
      return selectReduceWagerCount(state, {
        count,
        status,
        productId,
        pagingSortKey: lastWagersPaginationKey,
        wagerCount
      });
    }
  }
  return wagerCount;
};
const selectPagingSortKeys = (state, args) => selectReducePaginationKeys(state, args);
const selectWagerCount = (state, args) => selectReduceWagerCount(state, args);
const selectPlayerForecast = (state, _ref3) => {
  let productId = _ref3.productId,
    drawNumber = _ref3.drawNumber,
    wagerId = _ref3.wagerId,
    resultIdx = _ref3.resultIdx;
  if (!resultIdx || !drawNumber || !wagerId || !productId) {
    return null;
  }
  const data = tipsenApi.endpoints.getPlayerForecast.select({
    productId,
    drawNumber,
    wagerId,
    resultIdx
  })(state);
  return data.data;
};
setGlobal('svs.components.tipsen.querySelectors', {
  selectPagingSortKeys,
  selectWagerCount,
  selectPlayerForecast
});

 })(window);